import urlFilter from "../filters/url.filter";
import { DateType, Dictionary } from "./types/index";

/**
 * Данные по продукту.
 */
export class BankProductData {
  /**
   * Заголовок.
   */
  public Caption: string = "";

  /**
   * Описание.
   */
  public Description: string = "";

  /**
   * Идентификатор в каталоге.
   */
  public OperId: string = "";

  /**
   * Ссылка на картинку
   */
  public Picture: string = "";

  /**
   * Массив присутсвующих детей
   */
  public Childs: Array<any> = [];

  public ViewName: string = '';

  public captions: Dictionary<string> = {};

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null, captions: any = null) {
    if (src != null) {
      this.Caption = src.name ?? "";
      this.Description = src.desc ?? "";
      this.OperId = src.operId ?? "";
      this.Picture = urlFilter(src.picture) ?? "";
      if (src.type ===  'deposit') {
        this.ViewName = 'depositTypesList';
      } else if (src.type === 'credit') {
        this.ViewName = 'creditTypesList';
      }
    }
    if (captions) {
      for (const key in captions) {
        this.captions[key] = captions[key];
      }
    }
  }
}
